module.exports = __webpack_public_path__ + "static/media/faceboook.c3a774f2.svg";